/**
 * Private modules
 */
const {
  accountId,
  createQueryComponent,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  getAccountActivities: {
    properties: {
      params: {
        properties: {
          accountId,
        },
        required: ['accountId'],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
};
